import NotFound from './components/modules/dashboard/404.vue'
import BlankPage from './components/modules/common-page/BlankPage.vue'
import NotFoundSecond from './components/modules/dashboard/500.vue'

import Login from './components/Login.vue'
import Dashboard from './components/Dashboard.vue'
import UserList from './components/modules/user/UserList.vue' //  用户列表
import UserModify from './components/modules/user/UserModify.vue' //  用户录入
import TeacherList from "./components/modules/teacher/TeacherList" // 教师列表
import TeacherModify from "./components/modules/teacher/TeacherModify" // 教师录入
import Password from './components/Password.vue' //  密码修改
import DepartmentList from "./components/modules/department/DepartmentList" //  学校列表
import SalarySlipList from "./components/modules/salary/SalarySlipList" //  工资条列表
import ConfigList from './components/modules/system/ConfigList.vue' //  配置列表
import ConfigModify from './components/modules/system/ConfigModify.vue' //  配置编辑
import AuthModify from './components/modules/user/AuthModify.vue' // 权限编辑
import Feedback from './components/modules/feedback/FeedbackList.vue' // 意见反馈
import SystemMemoList from './components/modules/memo/SystemMemoList' //  系统备忘（服务提醒列表）
import SystemMemoModify from './components/modules/memo/SystemMemoModify' //  系统备忘（服务提醒列表）

// Routes
const routes = [
  {
    path: '/login?#',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Dashboard,
    meta: {requiresAuth: true},
    beforeEnter: (to, from, next) => {
      document.body.className += 'skin-dark sidebar-mini'
      next()
    },
    activate: function () {
      this.$nextTick(function () {
        // => 'DOM loaded and ready'
      })
    },
    children: [
      {
        path: '/blank-page',
        name: 'blank-page',
        component: BlankPage
      },
      {
        path: '/404',
        name: '404',
        component: NotFound
      },
      {
        path: '/500',
        name: '500',
        component: NotFoundSecond
      },
      {
        path: '/password',
        name: 'password',
        component: Password
      },
      {
        path: '/config/configList',
        name: 'configList',
        component: ConfigList,
        meta: {requiresAuth: true}
      },
      {
        path: '/config/configModify',
        name: 'configModify',
        component: ConfigModify,
        meta: {requiresAuth: true}
      },
      {
        path: '/staff/authModify',
        name: 'authModify',
        component: AuthModify,
        meta: {requiresAuth: true}
      },
      {
        path: '/user/userList',
        name: 'userList',
        component: UserList,
        meta: {requiresAuth: true}
      },
      {
        path: '/user/userModify',
        name: 'userModify',
        component: UserModify,
        meta: {requiresAuth: true}
      },
      {
        path: '/department/departmentList',
        name: 'departmentList',
        component: DepartmentList,
        meta: {requiresAuth: true}
      },
      {
        path: '/teacher/teacherList',
        name: 'teacherList',
        component: TeacherList,
        meta: {requiresAuth: true}
      },
      {
        path: '/teacher/teacherModify',
        name: 'teacherModify',
        component: TeacherModify,
        meta: {requiresAuth: true}
      },
      {
        path: '/salary/salarySlipList',
        name: 'salarySlipList',
        component: SalarySlipList,
        meta: {requiresAuth: true}
      },
      {
        path: '/feedback/feedbackList',
        name: 'feedbackList',
        component: Feedback,
        meta: {requiresAuth: true}
      },
      {
        path: '/memo/systemMemoList',
        name: 'systemMemoList',
        component: SystemMemoList,
        meta: {requiresAuth: true}
      },
      {
        path: '/memo/systemMemoModify',
        name: 'systemMemoModify',
        component: SystemMemoModify,
        meta: {requiresAuth: true}
      }
    ]
  },
  {
    // not found handler
    path: '*',
    redirect: '/login?#'
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/routes.js